<!-- Attendance Form -->
<section class="attendance-card" *ngIf="!isAttendanceCompleted">

    <!-- Card Header -->
    <div class="attendance-card-header">

        <div class="attendance-header-icon">

            <i class="ri-fingerprint-line"></i>

        </div>

        <div>

            <span class="attendance-eyebrow">
                Secure Attendance
            </span>

            <h2>
                Verify Your Identity
            </h2>

            <p>
                Enter your private 4-digit Attendance PIN.
                Your profile will automatically be identified
                after successful verification.
            </p>

        </div>

    </div>


    <!-- Card Body -->
    <div class="attendance-form-body">

        <!-- =====================================================
        VERIFICATION POPUP
        ===================================================== -->

        <div class="popup-overlay" *ngIf="showVerificationPopup">

            <div class="popup-container">
                <div class="popup-header">
                    <div class="popup-title">
                        <div class="popup-icon">
                            <i class="ri-shield-check-line"></i>
                        </div>

                        <div>

                            <span>

                                Employee Verification

                            </span>

                            <h3>

                                Identity Verified Successfully

                            </h3>

                        </div>

                    </div>

                    <button type="button" class="popup-close" (click)="showVerificationPopup = false">
                        <i class="ri-close-line"></i>
                    </button>

                </div>


                <!-- ===========================================
                VERIFIED EMPLOYEE
                ============================================ -->

                <div class="verified-employee-card">


                    <div class="popup-body">

                        <!-- ==========================================
                        ATTENDANCE HERO
                        =========================================== -->

                        <div class="attendance-hero" [class.check-in]="nextAction === 'check-in'"
                            [class.check-out]="nextAction === 'check-out'">

                            <div class="hero-status-icon">

                                <i [class]="actionIcon"></i>

                            </div>

                            <div class="hero-content">

                                <span class="hero-label">

                                    Identity Successfully Verified

                                </span>

                                <h2>

                                    {{ actionTitle }}

                                </h2>

                                <p>

                                    {{ actionDescription }}

                                </p>

                            </div>

                            <button type="button" class="hero-status-chip"
                                [class.check-out]="nextAction === 'check-out'"
                                [disabled]="!canMarkAttendance || isSubmitting" (click)="markAttendance()">

                                <i class="ri-loader-4-line spin" *ngIf="isSubmitting"></i>

                                <i *ngIf="!isSubmitting" [class]="actionIcon">
                                </i>

                                <span>
                                    {{
                                    isSubmitting
                                    ? 'Recording Attendance...'
                                    : (nextAction === 'check-in'
                                    ? 'CHECK IN'
                                    : 'CHECK OUT')
                                    }}
                                </span>

                            </button>

                        </div>

                        <!-- ==========================================
                        EMPLOYEE PROFILE
                        =========================================== -->

                        <div class="employee-profile-card">

                            <div class="employee-profile-left">

                                <div class="employee-avatar-large">

                                    <img *ngIf="verifiedEmployee?.profileImage" [src]="verifiedEmployee?.profileImage"
                                        [alt]="verifiedEmployee?.fullName">

                                    <span *ngIf="!verifiedEmployee?.profileImage">

                                        {{ employeeInitials }}

                                    </span>

                                </div>

                                <div class="employee-information">

                                    <span class="employee-tag">

                                        Verified Employee

                                    </span>

                                    <h3>

                                        {{ verifiedEmployee?.fullName }}

                                    </h3>

                                    <p>

                                        {{ verifiedEmployee?.department }}

                                    </p>

                                </div>

                            </div>

                            <div class="employee-type-badge"
                                [class.intern]="verifiedEmployee?.employeeType === 'intern'">

                                <i class="ri-user-star-line"></i>

                                <span>

                                    {{ verifiedEmployee?.employeeType | titlecase }}

                                </span>

                            </div>

                        </div>

                        <!-- ==========================================
                        EMPLOYEE INFORMATION GRID
                        =========================================== -->

                        <div class="employee-information-grid">

                            <div class="info-card">

                                <div class="info-icon">

                                    <i class="ri-id-card-line"></i>

                                </div>

                                <div>

                                    <span>Employee Code</span>

                                    <strong>

                                        {{ verifiedEmployee?.employeeCode }}

                                    </strong>

                                </div>

                            </div>

                            <div class="info-card">

                                <div class="info-icon">

                                    <i class="ri-building-2-line"></i>

                                </div>

                                <div>

                                    <span>Department</span>

                                    <strong>

                                        {{ verifiedEmployee?.department }}

                                    </strong>

                                </div>

                            </div>

                            <div class="info-card">

                                <div class="info-icon">

                                    <i class="ri-user-settings-line"></i>

                                </div>

                                <div>

                                    <span>Employment Type</span>

                                    <strong>

                                        {{ verifiedEmployee?.employeeType | titlecase }}

                                    </strong>

                                </div>

                            </div>

                        </div>


                    </div>
                    <!-- popup-body end -->

                </div>


            </div>

        </div>

        <!-- PIN SECTION -->
        <div class="form-section">

            <div class="section-heading">

                <div class="section-number">

                    01

                </div>

                <div>

                    <h3>

                        Attendance PIN

                    </h3>

                    <p>

                        Please enter the unique 4-digit PIN
                        assigned to you.

                    </p>

                </div>

            </div>


            <div class="attendance-pin-group">

                <label>

                    Attendance PIN

                    <span>*</span>

                </label>


                <div class="attendance-pin-input">

                    <div class="pin-icon">

                        <i class="ri-lock-password-line"></i>

                    </div>


                    <input id="attendancePin" [type]="showAttendancePin ? 'text' : 'password'" [value]="attendancePin"
                        (input)="onAttendancePinInput($event)" maxlength="4" inputmode="numeric" autocomplete="off"
                        placeholder="••••" [disabled]="
                            isSubmitting ||
                            isVerifying
                        ">


                    <div class="pin-dots">

                        <span *ngFor="let item of [0,1,2,3]" [class.filled]="attendancePin.length > item">
                        </span>

                    </div>


                    <button type="button" class="toggle-pin" (click)="toggleAttendancePin()">

                        <i [class]="
                            showAttendancePin
                            ? 'ri-eye-off-line'
                            : 'ri-eye-line'
                        ">
                        </i>

                    </button>

                </div>


                <div class="pin-security-message">

                    <i class="ri-shield-keyhole-line"></i>

                    <span>

                        Your identity will automatically
                        be detected after PIN verification.

                    </span>

                </div>

            </div>

        </div>


        <!-- VERIFY BUTTON -->

        <button *ngIf="!isVerified" type="button" class="verify-attendance-button" [disabled]="!canVerifyAttendance"
            (click)="verifyAttendance()">

            <i class="ri-loader-4-line spin" *ngIf="isVerifying">
            </i>

            <i class="ri-shield-check-line" *ngIf="!isVerifying">
            </i>

            <span>

                {{ isVerifying
                ? 'Verifying Identity...'
                : 'Verify Attendance PIN' }}

            </span>

            <i class="ri-arrow-right-line" *ngIf="!isVerifying">
            </i>

        </button>

        <!-- Progress -->
        <div class="attendance-progress modern-progress mt-3">


            <div class="progress-step active">

                <div class="progress-circle">

                    <i class="ri-lock-password-line"></i>

                </div>

                <div class="progress-content">

                    <strong>
                        Enter PIN
                    </strong>

                    <span>
                        Secure Authentication
                    </span>

                </div>

            </div>


            <div class="progress-line" [class.completed]="isVerified">
            </div>


            <div class="progress-step" [class.active]="isVerified">

                <div class="progress-circle">

                    <i class="ri-user-smile-line"></i>

                </div>

                <div class="progress-content">

                    <strong>
                        Verify Identity
                    </strong>

                    <span>
                        Employee Detected
                    </span>

                </div>

            </div>


            <div class="progress-line" [class.completed]="isVerified">
            </div>


            <div class="progress-step" [class.active]="isVerified">

                <div class="progress-circle">

                    <i class="ri-checkbox-circle-line"></i>

                </div>

                <div class="progress-content">

                    <strong>
                        Attendance
                    </strong>

                    <span>
                        Check-In / Check-Out
                    </span>

                </div>

            </div>

        </div>

        <!-- =====================================================
             VERIFIED EMPLOYEE
        ====================================================== -->

        <div class="modal fade" id="attendanceVerificationModal" tabindex="-1" aria-hidden="true">

            <div class="modal-dialog modal-dialog-centered modal-lg">

                <div class="modal-content border-0 shadow-lg">

                    <div class="modal-header">

                        <div class="d-flex align-items-center gap-3">

                            <div class="verification-modal-icon">

                                <i class="ri-shield-check-line"></i>

                            </div>

                            <div>

                                <h4 class="mb-0">

                                    Employee Verification

                                </h4>

                                <small class="text-muted">

                                    Identity Successfully Verified

                                </small>

                            </div>

                        </div>

                        <button type="button" class="btn-close" data-bs-dismiss="modal">
                        </button>

                    </div>

                    <div class="modal-body">

                        <!-- ===========================================
                        EXISTING ATTENDANCE CARD
                        ============================================ -->

                        <div class="attendance-action-card mt-4" [class.check-in]="nextAction==='check-in'"
                            [class.check-out]="nextAction==='check-out'">


                            <div class="action-icon">

                                <i [class]="actionIcon"></i>

                            </div>


                            <span class="action-eyebrow">

                                {{

                                nextAction==='check-in'

                                ? 'Office Arrival'

                                : 'Office Departure'

                                }}

                            </span>


                            <h2>

                                {{ actionTitle }}

                            </h2>


                            <p>

                                {{ actionDescription }}

                            </p>


                            <div class="attendance-summary">

                                <div class="summary-item">

                                    <label>

                                        Employee

                                    </label>

                                    <strong>

                                        {{ verifiedEmployee?.fullName }}

                                    </strong>

                                </div>

                                <div class="summary-item">

                                    <label>

                                        Department

                                    </label>

                                    <strong>

                                        {{ verifiedEmployee?.department }}

                                    </strong>

                                </div>

                                <div class="summary-item">

                                    <label>

                                        Employee Code

                                    </label>

                                    <strong>

                                        {{ verifiedEmployee?.employeeCode }}

                                    </strong>

                                </div>

                            </div>


                            <button class="confirm-attendance-button" [disabled]="!canMarkAttendance"
                                (click)="markAttendance()">

                                <i *ngIf="!isSubmitting" [class]="actionIcon">
                                </i>

                                <i *ngIf="isSubmitting" class="ri-loader-4-line spin">
                                </i>

                                <span>

                                    {{

                                    isSubmitting

                                    ? 'Recording Attendance...'

                                    : actionButtonText

                                    }}

                                </span>

                            </button>

                        </div>

                    </div>

                </div>

            </div>

        </div>



        <!-- =====================================================
             ERROR
        ====================================================== -->

        <div class="attendance-error-message" *ngIf="attendanceError">
            <i class="ri-error-warning-line"></i>
            <div>
                <strong> Verification Failed </strong>
                <p>{{ attendanceError }}</p>
            </div>
        </div>
    </div>
</section>





<!-- Attandance Summary -->
<!-- ============================================
 Attendance Summary Drawer
============================================= -->

<div class="attendance-summary-overlay" *ngIf="isAttendanceCompleted">

    <div class="attendance-summary-drawer">

        <!-- Header -->

        <div class="drawer-header">

            <div class="drawer-title">

                <div class="drawer-icon">

                    <i [class]="isCheckIn ? 'ri-login-circle-fill' : 'ri-logout-circle-fill'"></i>

                </div>

                <div>

                    <span>

                        {{ isCheckIn ? 'Check-In Successful' : 'Check-Out Successful' }}

                    </span>

                    <h4>

                        Attendance Summary

                    </h4>

                </div>

            </div>

            <button class="drawer-close" (click)="markAnotherAttendance()">

                <i class="ri-close-line"></i>

            </button>

        </div>


        <!-- Welcome Section -->

        <div class="welcome-section">

            <span>

                {{ greeting }}, {{ verifiedEmployee?.fullName }} 👋

            </span>

            <h3>

                {{ summaryTitle }}

            </h3>

            <p>

                {{ summaryMessage }}

            </p>

        </div>


        <!-- Success Banner -->

        <div class="success-banner">

            <i class="ri-shield-check-line"></i>

            <span>

                {{ attendanceMessage }}

            </span>

        </div>


        <!-- Employee -->

        <div class="employee-box">

            <div class="avatar">

                <img *ngIf="verifiedEmployee?.profileImage" [src]="verifiedEmployee?.profileImage"
                    [alt]="verifiedEmployee?.fullName">

                <span *ngIf="!verifiedEmployee?.profileImage">

                    {{ employeeInitials }}

                </span>

            </div>

            <div>

                <h5>

                    {{ verifiedEmployee?.fullName }}

                </h5>

                <p>

                    {{ verifiedEmployee?.designation }}

                </p>

            </div>

        </div>


        <!-- Attendance Details -->

        <div class="summary-grid">

            <div class="summary-item">

                <span>

                    Employee Code

                </span>

                <strong>

                    {{ verifiedEmployee?.employeeCode }}

                </strong>

            </div>

            <div class="summary-item">

                <span>

                    Department

                </span>

                <strong>

                    {{ verifiedEmployee?.department }}

                </strong>

            </div>

            <div class="summary-item">

                <span>

                    Attendance Date

                </span>

                <strong>

                    {{ attendanceResult?.attendanceDate | date:'dd MMM yyyy' }}

                </strong>

            </div>

            <div class="summary-item">

                <span>

                    Status

                </span>

                <strong class="success">

                    {{ attendanceResult?.attendanceStatus | titlecase }}

                </strong>

            </div>

            <div class="summary-item">

                <span>

                    Check In Time

                </span>

                <strong>

                    {{ formattedCheckInTime }}

                </strong>

            </div>

            <div class="summary-item">

                <span>

                    Check Out Time

                </span>

                <strong>

                    {{ formattedCheckOutTime }}

                </strong>

            </div>

            <div class="summary-item">

                <span>

                    Working Duration

                </span>

                <strong>

                    {{ formattedWorkingDuration }}

                </strong>

            </div>

            <div class="summary-item">

                <span>

                    Attendance State

                </span>

                <strong>

                    {{ attendanceResult?.attendanceState | titlecase }}

                </strong>

            </div>

        </div>


        <!-- Footer -->

        <button class="new-attendance-btn" (click)="markAnotherAttendance()">

            <i class="ri-refresh-line"></i>

            Mark Another Attendance

        </button>

    </div>

</div>